var render = function (_h,_vm) {var _c=_vm._c;return _c(_vm.props.to ? 'router-link' : _vm.props.href ? 'a' : 'button',_vm._b({ref:_vm.data.ref,tag:"button",staticClass:"base-button",class:(Array.isArray(_vm.data.class) ? _vm.data.class : [_vm.data.class]).concat( [_vm.data.staticClass],
    [{
      '_full-width': _vm.props.fullWidth,
      '__secondary': _vm.props.secondary,
      '__gradient': _vm.props.gradient,
      '__outline': _vm.props.outline,
      '__gray': _vm.props.gray,
      '__green': _vm.props.green,
      '__red': _vm.props.red,
      '__white': _vm.props.white,
      '__small': _vm.props.small,
      '__extra-small': _vm.props.extraSmall,
      '__round': _vm.props.round,
      '__disabled': _vm.props.disabled,
      '__transparent': _vm.props.transparent,
      '__text-like': _vm.props.textLike,
      '__gradient-text': _vm.props.gradientText,
    }] ),style:((Array.isArray(_vm.data.style) ? _vm.data.style : [_vm.data.style]).concat( [_vm.data.staticStyle])),attrs:{"disabled":_vm.props.disabled},on:{"click":function (e) {
      if (_vm.props.disabled || _vm.props.loading) { return; }
      _vm.listeners.click && _vm.listeners.click(e);
    }}},'button',_vm.props,false),[(_vm.props.gradientText)?_c('span',[(!_vm.props.loading)?_vm._t("default"):_c('base-spinner',{attrs:{"color":"var(--palette-gray-lighten-4)"}})],2):[(!_vm.props.loading)?_vm._t("default"):_c('base-spinner',{attrs:{"color":"var(--palette-bg)"}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }